import { requireStates } from "util";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";

const initialStates = [
  {
    name: "app.support",
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar
    },
    data: {
      navigation: {
        priority: 800,
        name: "Suporte"
      },
      authorization: context => context.user.is_admin
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/support/index.js